import React from 'react';

import OptionGallery from '../OptionBuilder/OptionGallery';
import LogoPicker from "./LogoPicker";


export default function LloydLogoChooser({option, cart, lloyd, callbacks}) {
  return <OptionGallery
    pickWith={LogoPicker}
    option={option}
    cart={cart}
    lloyd={lloyd}
    callbacks={callbacks}
  />
}

